import React from "react";
import App from "./components/App";
import {BrowserRouter} from 'react-router-dom';
import ReactDOM from "react-dom";
import {LangProvider} from "./providers/LangContext";
import Lang from "lang.js";
import messages from "./messages";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
require('formdata-polyfill');

const rootEl = document.getElementById('mainSite');
const lang = new Lang({messages, fallback: 'nl'});

let render = () => {
    const App = require('./components/App').default;
    ReactDOM.render(
        <BrowserRouter>
            <LangProvider value={{lang: lang}}>
                <App/>
            </LangProvider>
        </BrowserRouter>,
        rootEl
    )
};

if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
        module.hot.accept('./components/App', () => {
            setTimeout(render);
        })
    }
}

render();
